import { Col, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'

import { Progress as ProgressBase } from 'components/monitoring/components'
import BasePopover from 'components/monitoring/components/BasePopover'
import { getProgressPercentage } from '../../../../../utils'
import { prefixTable } from '../constants'
import styles from './LearningPathProgress.module.scss'

const prefixColumns = `${prefixTable}.columns`

const prefixStateList = 'monitoring.attributes.stateAdvanceList'
export const LearningPathProgress: React.FC<{
  progress: {
    finish: number
    inProgress: number
    pending: number
  }
  id: string
}> = ({ progress, id }) => {
  const { finish, inProgress, pending } = getProgressPercentage([progress])
  const { t } = useTranslation()

  const labels = [
    {
      classNameColor: styles.finish,
      label: t(`${prefixStateList}.finish`),
      value: finish,
    },
    {
      classNameColor: styles.inProgress,
      label: t(`${prefixStateList}.inProgress`),
      value: inProgress,
    },
    {
      classNameColor: styles.pending,
      label: t(`${prefixStateList}.pending`),
      value: pending,
    },
  ]

  return (
    <BasePopover
      id={id}
      popoverContent={
        <Row noGutters>
          <Col xs={12}>
            <b>{t('monitoring.learningPaths.table.popovers.progress.title')}</b>
          </Col>
          {labels.map(({ classNameColor, label, value }, i) => (
            <Col xs={12} key={i}>
              <Row noGutters>
                <Col xs="auto" className="d-flex align-items-center">
                  <div className={`${classNameColor} ${styles.dot}`} />
                </Col>
                <Col xs>{label} </Col>
                <Col xs="auto">{value}%</Col>
              </Row>
            </Col>
          ))}
        </Row>
      }
    >
      <ProgressBase
        className={styles.root}
        classes={{
          finish: styles.finish,
          inProgress: styles.inProgress,
          pending: styles.pending,
        }}
        finish={finish}
        inProgress={inProgress}
        pending={pending}
      />
      {t(`${prefixColumns}.progress`, {
        count: finish,
      })}
    </BasePopover>
  )
}

export default LearningPathProgress
